// Transport and view adapters keep warning deduplication testable without a browser.
module.exports = function createMarginCalls(adapters) {
    const inFlight = new Set();
    const seen = new Set();

    function show(response) {
        const warning = response && response.warning;
        if (!response || !response.success || response.stale || !response.html || !warning) return;
        const key = String(warning.key);
        if (seen.has(key) || adapters.hasSeen(key) || adapters.isBusy()) return;
        if (adapters.open(response.html) !== false) {
            seen.add(key);
            adapters.markSeen(key);
        }
    }

    function request(kind, id, key) {
        if (adapters.isBusy() || inFlight.size || !id || (key && (seen.has(String(key)) || adapters.hasSeen(String(key))))) return;
        const target = kind + ':' + id;
        if (inFlight.has(target)) return;
        inFlight.add(target);
        adapters.request(kind, id, show, () => inFlight.delete(target));
    }

    return {
        request,
        update(warnings) {
            for (const warning of (Array.isArray(warnings) ? warnings : [warnings])) {
                if (warning) request(warning.kind, warning.kind === 'cross' ? warning.account_id : warning.trade_id, warning.key);
            }
        },
    };
};
